<template>
  <div
    class="alert alert-warning alert-dismissible fade show container"
    role="alert"
  >
    <font-awesome-icon
      :icon="['fas', 'lightbulb']"
      class="fa-2x icon-lightbulb-alert text-warning"
    />
    <span class="text-alert"
      ><strong>A new version of the PABX is now available.</strong> Please
      <strong>refresh</strong> your browser to get the latest version.</span
    >
    <button type="button" class="btn btn-sm btn-light float-right mr-5"  @click="reloadPage()">
      <font-awesome-icon :icon="['fas', 'redo-alt']" />
      Refresh
    </button>
    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "AlertNewVersion",
  methods: {
    reloadPage() {
      window.location.reload();
    }
  }
}
</script>

<style scoped>
.icon-lightbulb-alert {
  float: left;
  margin-right: 8px;
}

.text-alert {
  vertical-align: sub;
}
</style>